/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import{
	StyleSheet
} from "react-native";

import Output from "./Output";
import InputContainer from "../Inputs/Layout/InputContainer";
import InputLabel from "../Inputs/Layout/InputLabel";

import Style from "ae-style";

var styles = StyleSheet.create({
	text: {
		padding: Style.layout.paddingSmall
	}
});

export default function OutputList(props) {
	var schema = props.schema;
	var data = props.data || [];
	var items = schema.items;

	var returnValue = data.map(function(section, index){
		if(!section) return null;
		return (
			<Output key={index} style={styles.text} schema={items} data={section} contrast={props.contrast}  noPdfFullScreen={props.noPdfFullScreen}/>
		);
	});

	return (
		<InputContainer style={props.style}>
			<InputLabel contrast={props.contrast} schema={schema} />
			{returnValue}
		</InputContainer>
	);
}
